import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface SkillBarProps {
  name: string;
  percentage: number;
}

export default function SkillBar({ name, percentage }: SkillBarProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <span className="text-white font-body font-medium text-sm">{name}</span>
        <span className="text-gold font-cta font-semibold text-sm">{percentage}%</span>
      </div>
      <div className="h-2 bg-white/10 rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: isVisible ? `${percentage}%` : 0 }}
          transition={{ duration: 1.3, ease: 'easeOut', delay: 0.2 }}
          className="h-full bg-gradient-to-r from-gold to-goldDark rounded-full relative"
          style={{ boxShadow: '0 0 12px rgba(252, 211, 77, 0.25)' }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse" />
        </motion.div>
      </div>
    </div>
  );
}
